export class FileHelper {
    constructor(gudhub) {
        this.gudhub = gudhub;
    }

    fileInstallerHelper(appId, items, elementId) {
        const self = this;
        return new Promise(resolve => {
            const files = [[]];
            let chainPromises = Promise.resolve();
            let results = [];

            items.forEach(item => {
                const itemId = item.item_id;
                const field = item.fields.find(field => field.element_id === elementId);

                if(field && field.field_value) {
                    const fileIds = field.field_value.split('.');

                    fileIds.forEach(fileId => {
                        const newFile = {
                            source: fileId,
                            destination: {
                                app_id: appId,
                                item_id: itemId,
                                element_id: elementId
                            }
                        }

                        if(files[files.length - 1].length !== 10) { // 10 - max duplicate files
                            files[files.length - 1].push(newFile);
                        } else {
                            files.push([newFile]);
                        }
                    })
                }
            });

            files.forEach(filePack => {
                chainPromises = chainPromises.then(() => {
                    return self.gudhub.duplicateFile(filePack);
                }).then(result => {
                    results = [
                        ...results,
                        ...result
                    ]
                })
            });

            chainPromises.then(() => {
                items.forEach(item => {
                    const itemId = item.item_id;
                    const field = item.fields.find(field => field.element_id === elementId);

                    if(field && field.field_value) {
                        field.field_value = '';
                        results.forEach(file => {
                            if(file.item_id === itemId) {
                                field.field_value = field.field_value.split(',').filter(fileId => fileId).concat(file.file_id).join(',');
                            }
                        })
                    }
                })

                resolve();
            })
        });
    }
}
